import {
  CREATE_AD,
  DELETE_AD,
  END_LOADING_AD,
  FETCH_ADS,
  START_LOADING_AD,
  UPDATE_AD,
  UPDATE_AD_METRICS,
} from "../constants/advertConstants";

const initialState = {
  ads: [],
  loading: false,
};

export const advertsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADS:
      return { ...state, ads: action.payload };
    case CREATE_AD:
      return { ...state, ads: [...state.ads, action.payload] };
    case UPDATE_AD:
      return {
        ...state,
        ads: state.ads.map((ad) =>
          ad._id === action.payload._id ? action.payload : ad
        ),
      };
    case DELETE_AD:
      return {
        ...state,
        ads: state.ads.filter((ad) => ad._id !== action.payload),
      };
    // Merge realtime counters into the matching row only — no refetch, no
    // loading flicker. Ignores ads not currently in the list (e.g. another
    // market's banner) rather than resurrecting them.
    case UPDATE_AD_METRICS:
      return {
        ...state,
        ads: state.ads.map((ad) =>
          ad._id === action.payload.id
            ? {
                ...ad,
                impressions: action.payload.impressions ?? ad.impressions,
                clicks: action.payload.clicks ?? ad.clicks,
              }
            : ad
        ),
      };
    case START_LOADING_AD:
      return { ...state, loading: true };
    case END_LOADING_AD:
      return { ...state, loading: false };
    default:
      return state;
  }
};
